import React from "react";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
var ImageContent = function(param) {
    var content = param.content;
    var baseAssetPath = window.location.origin;
    if (Array.isArray(content)) {
        return /*#__PURE__*/ React.createElement(Text, {
            tag: "ul"
        }, content.map(function(imgPath) {
            return /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("img", {
                src: "".concat(baseAssetPath).concat(imgPath),
                alt: imgPath,
                width: 250
            }));
        }));
    }
    return /*#__PURE__*/ React.createElement(Row, null, /*#__PURE__*/ React.createElement("img", {
        src: "".concat(baseAssetPath).concat(content),
        alt: content,
        width: 250
    }));
};
export default ImageContent;

//# sourceMappingURL=ImageContent.js.map